import { Box, Typography } from '@mui/material';

import { OPACITY } from '../../../theme';
import { returnTestingParts } from '../growth';
import { GROWTH } from '../tokens';
import type { GrowthFigures } from '../types';
import { CardHead, GROWTH_CARD_SX, SMALL_SX, STRONG_SX, TEXT_SX } from './cardParts';

export function ReturnTestingCard({ figures, later, here, open }: { figures: GrowthFigures; later: string; here: boolean; open: boolean }) {
  const parts = returnTestingParts(figures, later, here, open);
  const faded = { opacity: open ? OPACITY.provisional : 1 };
  return (
    <Box component="section" data-testid="return-testing" sx={GROWTH_CARD_SX}>
      <CardHead title="Return testing" open={open} />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '24px 48px' }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
          <Typography component="strong" data-testid="return-testing-percent" sx={{ fontFamily: GROWTH.font, fontSize: '20px', lineHeight: '28px', fontWeight: 600, color: GROWTH.ink, fontVariantNumeric: 'tabular-nums' }} style={faded}>
            {`${parts.percent}%`}
          </Typography>
          <Typography component="span" sx={{ ...TEXT_SX, color: GROWTH.muted }}>
            {parts.main}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '32px' }}>
          {parts.parts.map((part) => (
            <Box key={part.label} data-testid="return-testing-part" sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }} style={faded}>
              <Typography component="small" sx={SMALL_SX}>
                {part.label}
              </Typography>
              <Typography component="b" sx={{ ...STRONG_SX, fontVariantNumeric: 'tabular-nums' }}>
                {part.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
